<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal :state="state" :hideable="!awaitingResponse" backdrop
    @hide="$emit('hide')">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <i18n v-if="user != null" tag="p" path="introduction.full"
        class="modal-introduction">
        <template #resetPassword>
          <strong>{{ $t('introduction.resetPassword') }}</strong>
        </template>
        <template #displayName>{{ user.displayName }}</template>
        <template #email>{{ user.email }}</template>
      </i18n>
      <div class="modal-actions">
        <button id="user-reset-password-button" :disabled="awaitingResponse"
          type="button" class="btn btn-primary" @click="resetPassword">
          {{ $t('action.resetPassword') }} <spinner :state="awaitingResponse"/>
        </button>
        <button :disabled="awaitingResponse" type="button" class="btn btn-link"
          @click="$emit('hide')">
          {{ $t('action.close') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { noop } from '../../util/util';

export default {
  name: 'UserResetPassword',
  components: { Modal, Spinner },
  mixins: [request()],
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object // eslint-disable-line vue/require-default-prop
  },
  data() {
    return {
      awaitingResponse: false
    };
  },
  methods: {
    resetPassword() {
      const data = { email: this.user.email };
      this.post('/users/reset/initiate?invalidate=true', data)
        .then(() => {
          this.$emit('success', this.user);
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Reset Password",
    "introduction": {
      "full": "Once you click {resetPassword} below, the password for the user “{displayName}” \u003c{email}> will be immediately invalidated. An email will be sent to {email} with instructions on how to proceed.",
      "resetPassword": "Reset password"
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Obnovit heslo",
    "introduction": {
      "full": "Po kliknutí na {resetPassword} bude heslo uživatele „{displayName}“ \u003c{email}> okamžitě neplatné. Bude vám zaslán e-mail na {email} s pokyny, jak postupovat.",
      "resetPassword": "Obnovit heslo"
    }
  },
  "de": {
    "title": "Passwort zurücksetzen",
    "introduction": {
      "full": "Sobald Sie unten {resetPassword} klicken, wird das Passwort des Benutzers \"{displayName}\" \u003c{email}> unmittelbar ungültig. Eine E-Mail wird an {email} gesendet mit Anweisungen wie weiter vorgegangen wird.",
      "resetPassword": "Passwort zurücksetzen"
    }
  },
  "es": {
    "title": "Restablecer contraseña",
    "introduction": {
      "full": "Una vez que presione {resetPassword} a continuación, la contraseña del usuario “{displayName}” \u003c{email}> será invalidada inmediatamente. Se enviará un correo electrónico a {email} con instrucciones de cómo proceder.",
      "resetPassword": "restablecer constraseña"
    }
  },
  "fr": {
    "title": "Réinitialiser le mot de passe",
    "introduction": {
      "full": "Une fois que vous avez cliqué sur {resetPassword} ci-dessous, le mot de passe de l'utilisateur \"{displayName}\" est \u003c{email}> sera immédiatement invalidé. Un courrier électronique sera envoyé à {email} avec des instructions sur la manière de procéder.",
      "resetPassword": "Réinitialiser le mot de passe"
    }
  }
}
</i18n>
